import { Model, modelRegistry } from './Model';
import { TerminalType } from '../types';
import { Store } from '../wrappers';
import CashRegister from './CashRegister';
export class Terminal extends Model {
    static entity = 'terminals';
    id = null;
    cash_register_id = null;
    name = '';
    key = '';
    type = TerminalType.cashRegister;
    uuid = null;
    platform = null;
    manufacturer = null;
    model = null;
    created_at = null;
    updated_at = null;
    static fields() {
        return {
            id: this.attr(null),
            cash_register_id: this.attr(null),
            name: this.attr(''),
            key: this.attr(''),
            type: this.attr(TerminalType.cashRegister),
            uuid: this.attr(null),
            platform: this.attr(null),
            manufacturer: this.attr(null),
            model: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null)
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
    static async current() {
        return Store.get('terminal') || undefined;
    }
    isCashRegister() {
        return this.type === TerminalType.cashRegister;
    }
    isOrderingDevice() {
        return this.type === TerminalType.orderingDevice;
    }
    isKitchenDisplaySystem() {
        return this.type === TerminalType.kitchenDisplaySystem;
    }
    getCashRegister() {
        if (!this.cash_register_id)
            return undefined;
        return CashRegister.find(this.cash_register_id);
    }
}
export default Terminal;
modelRegistry.register('Terminal', Terminal);
//# sourceMappingURL=Terminal.js.map